// Registered by hand rather than by the Rails manifest generator, so adding a
// controller is a visible edit in a diff rather than a regenerated file.

import { application } from "./application"

import FilterFormController from "./filter_form_controller"
application.register("filter-form", FilterFormController)

import AnimatedFaviconController from "./animated_favicon_controller"
application.register("animated-favicon", AnimatedFaviconController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import ConfirmActionController from "./confirm_action_controller"
application.register("confirm-action", ConfirmActionController)

import DetailsToggleController from "./details_toggle_controller"
application.register("details-toggle", DetailsToggleController)

import AccountMenuController from "./account_menu_controller"
application.register("account-menu", AccountMenuController)

import SelectAllController from "./select_all_controller"
application.register("select-all", SelectAllController)

import PanelNavGroupController from "./panel_nav_group_controller"
application.register("panel-nav-group", PanelNavGroupController)


import LayoffSourcesController from "./layoff_sources_controller"
application.register("layoff-sources", LayoffSourcesController)

import LayoffDetailsController from "./layoff_details_controller"
application.register("layoff-details", LayoffDetailsController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import RoleCompareController from "./role_compare_controller"
application.register("role-compare", RoleCompareController)

import BrowseController from "./browse_controller"
application.register("browse", BrowseController)

import QuestionBrowserController from "./question_browser_controller"
application.register("question-browser", QuestionBrowserController)

// Ported Primer Brand behaviours. See app/components/brand/README.md.
import BrandActionMenuController from "./brand_action_menu_controller"
application.register("brand-action-menu", BrandActionMenuController)

import BrandAnchorNavController from "./brand_anchor_nav_controller"
application.register("brand-anchor-nav", BrandAnchorNavController)

import BrandAnimationProviderController from "./brand_animation_provider_controller"
application.register("brand-animation-provider", BrandAnimationProviderController)

import BrandIdeController from "./brand_ide_controller"
application.register("brand-ide", BrandIdeController)

import BrandLogoSuiteController from "./brand_logo_suite_controller"
application.register("brand-logo-suite", BrandLogoSuiteController)

import BrandMediaPlaylistController from "./brand_media_playlist_controller"
application.register("brand-media-playlist", BrandMediaPlaylistController)

import BrandMinimalVideoPlayerController from "./brand_minimal_video_player_controller"
application.register("brand-minimal-video-player", BrandMinimalVideoPlayerController)

import BrandNavListController from "./brand_nav_list_controller"
application.register("brand-nav-list", BrandNavListController)

import BrandRiverStoryScrollController from "./brand_river_story_scroll_controller"
application.register("brand-river-story-scroll", BrandRiverStoryScrollController)

import BrandSubNavController from "./brand_sub_nav_controller"
application.register("brand-sub-nav", BrandSubNavController)

import BrandSubdomainNavBarController from "./brand_subdomain_nav_bar_controller"
application.register("brand-subdomain-nav-bar", BrandSubdomainNavBarController)

import BrandTabsController from "./brand_tabs_controller"
application.register("brand-tabs", BrandTabsController)

import BrandTextCursorAnimationController from "./brand_text_cursor_animation_controller"
application.register("brand-text-cursor-animation", BrandTextCursorAnimationController)

import BrandTextRevealAnimationController from "./brand_text_reveal_animation_controller"
application.register("brand-text-reveal-animation", BrandTextRevealAnimationController)

import BrandTooltipController from "./brand_tooltip_controller"
application.register("brand-tooltip", BrandTooltipController)

import BrandVideoPlayerController from "./brand_video_player_controller"
application.register("brand-video-player", BrandVideoPlayerController)

import HumanCheckController from "./human_check_controller"
application.register("human-check", HumanCheckController)

import HeroEffectsController from "./hero_effects_controller"
application.register("hero-effects", HeroEffectsController)

import EventsPageController from "./events_page_controller"
application.register("events-page", EventsPageController)

import EventPlaceController from "./event_place_controller"
application.register("event-place", EventPlaceController)

import PixelMapController from "./pixel_map_controller"
application.register("pixel-map", PixelMapController)
